module.exports = __webpack_public_path__ + "img/hotel-quinta-da-marinha-resort.4c3c6cf8.jpg";